import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, tap, withLatestFrom, filter, mergeMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import {
    PCGRequested,
    PCGLoaded,
    PCGCancelled,
    PCGActionTypes,
    PCGActions,
} from './pcg.actions';
import { PCGAPIService } from 'app/api/pcg.api.service';
import { sortBy } from 'lodash';
import { select, Store } from '@ngrx/store';
import { selectPCGLoaded, selectPCG } from './pcg.selectors';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';

@Injectable()
export class PCGEffects {
    @Effect()
    loadPCG$ = this.actions$.pipe(
        ofType<PCGRequested>(PCGActionTypes.PCGRequested),
        withLatestFrom(this.store.pipe(select(selectPCGLoaded))),
        filter(([action, pcgLoaded]) => !pcgLoaded),
        mergeMap(() =>
          this.pcgApiService
              .Pcg()
              .pipe(
                  map(conn => new PCGLoaded({ pcg: sortBy(conn.items, 'id') })),
                  catchError(error => {
                    const errorMessage = parseErrorMessage(error);
                    return of(new PCGCancelled({ errorMessage }));
                })
              )
          )
    );

    constructor(
        private actions$: Actions<PCGActions>,
        private store: Store<AppState>,
        private pcgApiService: PCGAPIService,
    ) {}
}
